
import DeviceStorage from './../../components/DeviceStorage/DeviceStorage';
import store from '../../store';
import settings from '../../devices/all/settings';
import {
    RegisterMethodType, ContractType, PaymentMethodType, InteractionType,
    EVENT_SIGN_UP, EVENT_LOGIN, EVENT_ADD_PAYMENT, EVENT_SELECT_CONTENT, EVENT_VIEW_ITEM, EVENT_INTERACTION_CONTENT, EVENT_BEGIN_CHECKOUT, EVENT_ADD_PAYMENT_INFO, EVENT_PURCHASE, EVENT_CONTENT_PLAY, EVENT_CONTENT_PAUSE, EVENT_CONTENT_BACK, EVENT_CONTENT_ADVANCE, EVENT_INTERACTION_PLAYER, EVENT_CONTENT_PROGRESS, EVENT_SEARCH, EVENT_PRIVACY_POLICES,
    METHOD_IPTELMEX, METHOD_EMAIL,
    PAYMENT_METHOD_TELMEX,
    USER_TYPE_ANONIMO, USER_TYPE_REGISTRADO, PRIVACY_POLICES_CONTINUE, PRIVACY_POLICES_POLICES, PRIVACY_POLICES_TERMS,
    PLAN_SELECTOR, CONTENT_AVAILABILITY_SUBSCRIPTION, DEVICE, HOME_USER, HOME_USER_LITE, HOME_USER_SECTION_G4,
    NODE_PREMIUM, NODE_PREMIUM_LITE, NODE_PREMIUM_SECTION_G4
} from './GA4Constants';
import 'src/extensions/string.extensions';
import { AdsUtils } from 'src/AAF/Ads/Utils';
import { count } from 'console';
import Constants from 'src/AAF/Ads/Constans';

declare var window: any;

interface ISendPlanSelectorRibbonHomePremium {
  content_section: string
  content_id: string
  content_name: string
  content_type: string
  content_brand: string
  content_list: string
  content_price: string
}

export class GA4 {

    private dataLayer: any = window.dataLayer || [];
    private user_id: string;
    private debuggMode: boolean = settings.ga4.debugger_enabled;
    private isEnabled: boolean = settings.ga4.eneabled;

    constructor(user_id?: string) {
        this.user_id = user_id || DeviceStorage.getItem('user_id') || '';
    }

    private getUserId(): string {
        const { user: { user_id = 'N/D' } = {} } = store.getState() || {};
        return user_id;
    }

    private isDebuggingModeAvtive(): boolean {
        return this.debuggMode;
    }

    private send(dataLayer: any, method: any) {

        if (!this.isEnabled) return;

        if (this.isDebuggingModeAvtive()) console.log(`%c ***** = [GA4] dataLayer = ***** %c` + JSON.stringify(dataLayer, null, "\t") + `%c `  + method, 'background-color:red; color:black', 'background-color:green',  'background-color:white;color:black;')

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(dataLayer)

        const {event, ...rest} = dataLayer;
    if (this.isDebuggingModeAvtive())  console.log('GA4 ', event, '\n',rest);

    }


    /**
     * ID A1 [Registro] El evento se debe activar con el click en el boton 'SIGUIENTE'
     * @param method Corresponde al método de registro escogido por el usuario
     * @param user_id Corresponde a un identificador de usuario con el que se pueda cruzar con base de datos. Se recomienda que el valor de la variable user_id sea una cookie propia que se active con el registro para así, desde GTM crear la variable que se convierta en una constante de todas las interacciones del usuario
     * @param user_type Tipo de usuario en Claro Video, puede ser anonimo o registrado
     * @param country Pais en el que se encuentra la app, si esta logueado pais asociado a esa cuenta de usuario
     */
    public sendRegisterEvent(method: RegisterMethodType, user_id, user_type: string = getUserType(), country: string = getCountry()): void {

        if (!this.isEnabled) return;

        this.send({
            event: EVENT_SIGN_UP,
            method: method,
            user_id: user_id,
            user_type,
            country
        }, 'A1 [Registro] - sendRegisterEvent');
    }

    /**
     * ID A3 [Registro IpTelmex] el evento se debe activar con la carga de la pantalla de 'Bienvenida'
     * @param user_id Corresponde a un identificador de usuario con el que se pueda cruzar con base de datos. Se recomienda que el valor de la variable user_id sea una cookie propia que se active con el registro para así, desde GTM crear la variable que se convierta en una constante de todas las interacciones del usuario
     */
    public sendRegisterIPTelmexEvent(user_id = this.getUserId()): void {

        if (!this.isEnabled) return;

        this.send({
            event: EVENT_SIGN_UP,
            method: METHOD_IPTELMEX,
            user_id: this.getUserId(),
        }, 'A3 [Registro IpTelmex] - sendRegisterIPTelmexEvent');
    }

    /**
     * ID B1 [inicio sesión] El evento se debe activar con el click en el boton 'SIGUIENTE'
     * @param method corresponde al método de registro escogido por el usuario
     * @param user_id corresponde a un identificador de usuario con el que se pueda cruzar con base de datos. Se recomienda que el valor de la variable user_id sea una cookie propia que se active con el registro para así, desde GTM crear la variable que se convierta en una constante de todas las interacciones del usuario
     * @param user_type Tipo de usuario en Claro Video, puede ser anonimo o registrado
     * @param country Pais en el que se encuentra la app, si esta logueado pais asociado a esa cuenta de usuario
     */
    public sendLoginEvent(method: string = METHOD_EMAIL, user_id = this.getUserId(), user_type: string = getUserType(), country: string = getCountry()): void {

        if (!this.isEnabled) return;

        this.send({
            event: EVENT_LOGIN,
            method: method,
            user_id,
            user_type,
            country,
        }, 'B1 [inicio sesión] - sendLoginEvent');
    }

    /**
     * ID C1 El evento se debe activar con con el click en el boton 'CONTINUAR'
     * @param contract_type Corresponde al tipo de contrato [negocio|hogar]
     * @param payment_method Corresponde al método de pago seleccionado por el usuario
     */
    public addPaymentMethodWithContractEvent(contract_type: ContractType, payment_method: typeof PAYMENT_METHOD_TELMEX): void {
        if (!this.isEnabled) return;
        this.send({
            event: EVENT_ADD_PAYMENT,
            payment_method: payment_method,
            contract_type: contract_type,
        }, 'C1 - addPaymentMethodWithContractEvent');
    }

    /**
     * ID C2, C3, C4
     * @param payment_method corresponde al método de pago seleccionado por el usuario
     */
    public sendAddPaymentMethodEvent(payment_method: PaymentMethodType): void {
        if (!this.isEnabled) return;
        this.send({
            event: EVENT_ADD_PAYMENT,
            payment_method: payment_method,
        }, 'ID C2, C3, C4 - sendAddPaymentMethodEvent');
    }

    /**
     * D1-D10, D12 El evento se debe activar con el click en el contenido que seleccione el usuario
     * @param section Nombre del nodo en el que se encuentra el usuario
     * @param list Corresponde al nombre de la lista de carruseles disponibles
     * @param id Identificador único del contenido
     * @param name Nombre del contenido
     * @param type [pelicula|serie|documental|canal tv]
     * @param category Categorías a la que pertenece el contenido
     * @param availability [gratuito|por suscripcion|alquiler|por suscripcion addon|compra episodio|compra temporada completa|comprar pelicula]
     * @param user_id corresponde a un identificador de usuario con el que se pueda cruzar con base de datos. Se recomienda que el valor de la variable user_id sea una cookie propia que se active con el registro para así, desde GTM crear la variable que se convierta en una constante de todas las interacciones del usuario
     * @param user_type Tipo de usuario en Claro Video, puede ser anonimo o registrado
     * @param country Pais en el que se encuentra la app, si esta logueado pais asociado a esa cuenta de usuario
     */
    public sendSelectContentEvent(section: string, list: string, id: string, name: string, type: string, category: string, availability: string,
        user_id: string = this.getUserId(), user_type: string = getUserType(), country: string = getCountry()): void {

        if (!this.isEnabled) return;

        const content_id = (id)?.toString().clearString();

        const dataLayer = {
            event: EVENT_SELECT_CONTENT,
            content_section: section?.clearString(),
            content_list: list?.clearString(),
            content_id,
            content_name: name?.clearString(),
            content_type: type?.clearString(),
            content_category: category?.clearString(),
            content_availability: availability?.clearString(),
            user_type,
            user_id,
            country,
            device: DEVICE
        }

        this.send(dataLayer, 'ID D1-D10, D12 - sendSelectContentEvent');
    }

    /**
     * D11 [Selección de contenido - Inicio] El evento se debe activar con el click de alguno de los 2 botones
     * @param id Identificador único del contenido
     * @param name Nombre del contenido
     * @param category Tipo de contenido Ejem. [pelicula|serie|documental|canal tv]
     * @param category2 Categorías a las que pertenece el contenido Ejem. [{categorías a la que pertenece el contenido}|no aplica]
     * @param category3 Tipo de disponibilidad del contenido [gratuito|por suscripcion|alquiler|por suscripcion addon|compra episodio|compra temporada completa|comprar pelicula]
     * @param category4 [temporada{numero}|episodio{numero y nombre}|no aplica]
     * @param brand Marca de la suscripción Ejem. [hbo|claro video|fox sport|noggin|edye|paramount]
     * @param list_name [home inicio|vcard|player|fin player|player tv]
     * @param price Precio del contenido |.00
     * @param quantity Cantidad
     * @param user_id corresponde a un identificador de usuario con el que se pueda cruzar con base de datos. Se recomienda que el valor de la variable user_id sea una cookie propia que se active con el registro para así, desde GTM crear la variable que se convierta en una constante de todas las interacciones del usuario
     * @param user_type Tipo de usuario en Claro Video, puede ser anonimo o registrado
     * @param country Pais en el que se encuentra la app, si esta logueado pais asociado a esa cuenta de usuario
     */
    public sendPlanSelectorEvent(id: string, name: string,
        category: string, category2: string, category3: string, category4: string,
        brand: string, list_name: string, price: string, quantity: number,
        user_id: string = this.getUserId(), user_type: string = getUserType(), country: string = getCountry()) {

        if (!this.isEnabled) return;

        const dataLayer = {
            event: EVENT_BEGIN_CHECKOUT,
            item_id: id,
            item_name: name?.clearString(),
            item_category: category?.clearString(),
            item_category2: category2?.clearString(),
            item_category3: category3?.clearString(),
            item_category4: category4?.clearString(),
            item_brand: brand?.clearString(),
            item_list_name: list_name?.clearString(),
            price: price?.clearCurrency(),
            quantity: quantity,
            user_type,
            country,
            user_id
        }
        this.send(dataLayer, 'D11 [Selección de contenido - Inicio] - sendPlanSelectorEvent');
    }

    /**
     * D13 [Selección de contenido - Vcard] El evento se debe activar con el click en el contenido que seleccione el usuario
     * @param section Nombre del nodo en el que se encuentra el usuario
     * @param list Corresponde al nombre de la lista de carruseles disponibles
     * @param id Identificador único del contenido
     * @param name Nombre del contenido
     * @param type [pelicula|serie|documental|canal tv]
     * @param category Categorías a la que pertenece el contenido
     * @param availability [gratuito|por suscripcion|alquiler|por suscripcion addon|compra episodio|compra temporada completa|comprar pelicula]
     * @param episode Nnombre y número del episodio
     * @param user_id corresponde a un identificador de usuario con el que se pueda cruzar con base de datos. Se recomienda que el valor de la variable user_id sea una cookie propia que se active con el registro para así, desde GTM crear la variable que se convierta en una constante de todas las interacciones del usuario
     * @param user_type Tipo de usuario en Claro Video, puede ser anonimo o registrado
     * @param country Pais en el que se encuentra la app, si esta logueado pais asociado a esa cuenta de usuario
     */
    public sendSelectContentSerieEvent(section: string, list: string, id: string, name: string, type: string, category: string, availability: string, episode: string,
        user_id: string = this.getUserId(), user_type: string = getUserType(), country: string = getCountry()): void {

        if (!this.isEnabled) return;

        const content_id = (id).toString().clearString();

        const dataLayer = {
            event: EVENT_SELECT_CONTENT,
            content_section: section?.clearString(),
            content_list: list?.clearString(),
            content_id,
            content_name: name?.clearString(),
            content_type: type?.clearString(),
            content_category: category?.clearString(),
            content_availability: availability?.clearString(),
            content_episode: episode?.clearString(),
            user_type,
            country,
            user_id,
            device: DEVICE
        }
        this.send(dataLayer, 'D13 [Selección de contenido - Vcard] - sendSelectContentSerieEvent');
    }

    /**
     * E1 El evento se debe activar cuando cargue el detalle del contenido seleccionado por el usuario
     * @param id Identificador único del contenido
     * @param name Nnombre del contenido
     * @param category [pelicula|serie|documental|canal tv]
     * @param category2 Categorías a la que pertenece el contenido
     * @param category3 [gratuito|por suscripcion|alquiler|por suscripcion addon|compra episodio|compra temporada completa|comprar pelicula]
     * @param category4 [temporada{numero}|episodio{numero y nombre}|no aplica]
     * @param brand [hbo|claro video|fox sport|noggin|edye|paramount|no aplica]
     * @param list_name [home inicio|vcard|player|fin player|player tv]
     * @param price [Precio del contenido|0.00]
     * @param quantity 1
     */
    public sendContentDetailEvent(id: string, name: string,
        category: string, category2: string, category3: string, category4: string,
        brand: string, list_name: string, price: string, quantity: number = 1) {

        if (!this.isEnabled) return;

            const dataLayer: any = {
            event: EVENT_VIEW_ITEM,
            ecommerce: {
            items: [{
                item_id: id,
                item_name: name?.clearString(),
                item_category: category?.clearString(),
                item_category2: category2?.clearString(),
                item_category3: category3?.clearString(),
                item_category4: category4?.clearString(),
                item_brand: brand?.clearString(),
                item_list_name: list_name?.clearString(),
                price: price?.clearCurrency(),
                quantity: quantity
            }]
        }}
        this.send(dataLayer, 'E1 [Selección de contenido - Vcard] - sendContentDetailEvent');
}


    /**
     * E2 El evento se debe activar con el click sobre cualquiera de las opciones señaladas y escogida por el usuario
     * @param interactionType Nombre de la interacción [reproducir|ver trailer|quitar de mi lista|agregar a mi lista]
     * @param section Nombre del nodo en el que se encuentra el usuario
     * @param id Identificador único del contenido
     * @param name Nombre del contenido
     * @param contentType Tipo de contenido [pelicula|serie|documental|canal tv]
     * @param category Categorías a la que pertenece el contenido [comedia, accion, drama, ciencia ficcion]
     * @param availability Tipo de disponibilidad del contenido [gratuito|por suscripcion|alquiler|por suscripcion addon|compra episodio|compra temporada completa|comprar pelicula]
     * @param user_id corresponde a un identificador de usuario con el que se pueda cruzar con base de datos. Se recomienda que el valor de la variable user_id sea una cookie propia que se active con el registro para así, desde GTM crear la variable que se convierta en una constante de todas las interacciones del usuario
     * @param user_type Tipo de usuario en Claro Video, puede ser anonimo o registrado
     * @param country Pais en el que se encuentra la app, si esta logueado pais asociado a esa cuenta de usuario
     */
    public sendInteractContentEvent(interactionType: InteractionType, section: string,
        id: string, name: string, contentType: string, category: string, availability: string,
        user_id: string = this.getUserId(), user_type: string = getUserType(), country: string = getCountry()) {

        if (!this.isEnabled) return;


        const dataLayer = {
            event: EVENT_INTERACTION_CONTENT,
            interaction_type: interactionType,
            content_section: section?.clearString(),
            item_id: id?.clearString(),
            content_name: name?.clearString(),
            content_type: contentType?.clearString(),
            content_category: category?.clearString(),
            content_availability: availability?.clearString(),
            user_type,
            country,
            user_id
        }
        this.send(dataLayer, 'E2 [Selección de contenido - Vcard] - sendInteractContentEvent');
    }


    /**
     * ID'S E4-E10 El evento se debe activar con el click sobre cualquiera de las opciones señaladas y escogida por el usuario
     * @param id Identificador único del contenido
     * @param name Nombre del contenido
     * @param category Tipo de contenido [pelicula|serie|documental|canal tv]
     * @param category2 Categorías a las que pertenece el contenido | no aplica
     * @param category3 Tipo de disponibilidad del contenido [gratuito|por suscripcion|alquiler|por suscripcion addon|compra episodio|compra temporada completa|comprar pelicula]
     * @param category4 Numero de temporada o numero y nombre de episodio [temporada{numero}|episodio{numero y nombre}|no aplica]
     * @param brand Marca de la suscripción [hbo|claro video|fox sport|noggin|edye|paramount|no aplica]
     * @param list_name Ubicación dentro del sitio web
     * @param price Precio del contenido [{precio del contenido}|0.00]
     * @param quantity Cantidad a comprar
     * @param user_id corresponde a un identificador de usuario con el que se pueda cruzar con base de datos. Se recomienda que el valor de la variable user_id sea una cookie propia que se active con el registro para así, desde GTM crear la variable que se convierta en una constante de todas las interacciones del usuario
     * @param user_type Tipo de usuario en Claro Video, puede ser anonimo o registrado
     * @param country Pais en el que se encuentra la app, si esta logueado pais asociado a esa cuenta de usuario
     */
    public sendStartCheckoutEvent(id: string, name: string,
        category: string, category2: string, category3: string, category4: string,
        brand: string, list_name: string, price: string, quantity: number = 1,
        user_id: string = this.getUserId(), user_type: string = getUserType(), country: string = getCountry()) {


        const dataLayer = {
            event: EVENT_BEGIN_CHECKOUT,
            ecommerce: {
            items: [{
                item_id: id,
                item_name: name?.clearString(),
                item_category: category?.clearString(),
                item_category2: category2?.clearString(),
                item_category3: category3?.clearString(),
                item_category4: category4?.clearString(),
                item_brand: brand?.clearString(),
                item_list_name: list_name?.clearString(),
                price: price?.clearCurrency(),
                quantity: quantity,
                user_type,
                country,
                user_id}
                ]
            }
        }
        this.send(dataLayer, 'E4-E10 [Detalle de contenido - Sin derecho (usuario registrado con prepago)] - sendStartCheckoutEvent');
    }

    /**
     * ID F1-F2 El evento se debe activar con el click en el boton 'CONTRATAR' / 'ALQUILAR'
     * @param type Corresponde al método de pago seleccionado por el usuario.
     * @param name
     * @param id
     * @param price
     * @param brand
     * @param category
     * @param category2
     * @param category3
     * @param category4
     * @param quantity
     */
    public sendPaymentMethodAddedEvent(type: string, name: string, id: string, price: string, brand: string, category: string, category2: string, category3: string, category4: string, quantity: number = 1) {

        if (!this.isEnabled) return;

        const dataLayer = {
            event: EVENT_ADD_PAYMENT_INFO,
            ecommerce: {
            payment_type: type,
            items: [{
                item_name: name?.clearString(),
                item_id: id?.clearString(),
                price: price?.clearCurrency(),
                item_brand: brand?.clearString(),
                item_category: category?.clearString(),
                item_category2: category2?.clearString(),
                item_category3: category3?.clearString(),
                item_category4: category4?.clearString(),
                quantity: quantity}]
            }
        }
        this.send(dataLayer, 'F1 [Compra - Agregar medio de pago] - sendPaymentMethodAddedEvent');
    }

    /**
     *
     * @param value Valor total de la compra
     * @param transactionId Identificador de la transacción
     * @param cupon Número del cupon utilizado
     * @param name
     * @param itemId
     * @param price
     * @param brand
     * @param category
     * @param category2
     * @param category3
     * @param category4
     * @param quantity
     */
    public sendBuyEvent(value: string, transactionId: string, cupon: string, name: string, itemId: string, price: string, brand: string,
        category: string, category2: string, category3: string, category4: string, quantity: number = 1) {

        if (!this.isEnabled) return;

        const dataLayer = {
            event: EVENT_PURCHASE,
            ecommerce: {
                value: value.clearCurrency(),
                transaction_id: transactionId?.clearString(),
                cupon: cupon?.clearString(),
                items:[{
                    item_name: name?.clearString(),
                    item_id: itemId?.clearString(),
                    price: price?.clearCurrency(),
                    item_brand: brand?.clearString(),
                    item_category: category?.clearString(),
                    item_category2: category2?.clearString(),
                    item_category3: category3?.clearString(),
                    item_category4: category4?.clearString(),
                    quantity: quantity,
                }]

        }}
        this.send(dataLayer, 'F3 [Compra - Compra] - sendBuyEvent');
    }

    /**
     *
     * @param id
     * @param name
     * @param type
     * @param category
     * @param availability
     * @param episode
     * @param list
     * @param user_id corresponde a un identificador de usuario con el que se pueda cruzar con base de datos. Se recomienda que el valor de la variable user_id sea una cookie propia que se active con el registro para así, desde GTM crear la variable que se convierta en una constante de todas las interacciones del usuario
     * @param user_type Tipo de usuario en Claro Video, puede ser anonimo o registrado
     * @param country Pais en el que se encuentra la app, si esta logueado pais asociado a esa cuenta de usuario
     */
    public sendPlayContentEvent(id: string, name: string, type: string, category: string, availability: string, episode: string, list: string,
        user_id: string = this.getUserId(), user_type: string = getUserType(), country: string = getCountry()) {

        if (!this.isEnabled) return;

        const content_id = (id).toString().clearString();

        const dataLayer = {
            event: EVENT_CONTENT_PLAY,
            content_id,
            content_name: name?.clearString(),
            content_type: type?.clearString(),
            content_category: category?.clearString(),
            content_availability: availability?.clearString(),
            content_episode: episode?.clearString(),
            content_list: list?.clearString(),
            user_type,
            country,
            user_id,
        }
        this.send(dataLayer, 'G1 [Reproductor - Reproducción de contenido] - sendPlayContentEvent');
    }

    public sendPauseContentEvent(id: string, name: string, type: string, category: string, availability: string, episode: string, list: string,
        user_id: string = this.getUserId(), user_type: string = getUserType(), country: string = getCountry()) {

        if (!this.isEnabled) return;

        const content_id = (id).toString().clearString();

        const dataLayer = {
            event: EVENT_CONTENT_PAUSE,
            content_id,
            content_name: name?.clearString(),
            content_type: type?.clearString(),
            content_category: category?.clearString(),
            content_availability: availability?.clearString(),
            content_episode: episode?.clearString(),
            content_list: list?.clearString(),
            user_type,
            country,
            user_id,
        }
        this.send(dataLayer, 'G2 [Reproductor - Reproducción de contenido] - sendPauseContentEvent');
    }

    public sendBackContentEvent(id: string, name: string, type: string, category: string, availability: string, episode: string, list: string,
        user_id: string = this.getUserId(), user_type: string = getUserType(), country: string = getCountry()) {

        if (!this.isEnabled) return;
        const content_id = (id).toString().clearString();

        const dataLayer = {
            event: EVENT_CONTENT_BACK,
            content_id,
            content_name: name?.clearString(),
            content_type: type?.clearString(),
            content_category: category?.clearString(),
            content_availability: availability?.clearString(),
            content_episode: episode?.clearString(),
            content_list: list?.clearString(),
            user_type,
            country,
            user_id,
        }
        this.send(dataLayer, 'G3 [Reproductor - Reproducción de contenido] - sendBackContentEvent');
    }

    public sendAdvanceContentEvent(id: string, name: string, type: string, category: string, availability: string, episode: string, list: string,
        user_id: string = this.getUserId(), user_type: string = getUserType(), country: string = getCountry()) {

        if (!this.isEnabled) return;

        const content_id = (id).toString().clearString();

        const dataLayer = {
            event: EVENT_CONTENT_ADVANCE,
            content_id,
            content_name: name?.clearString(),
            content_type: type?.clearString(),
            content_category: category?.clearString(),
            content_availability: availability?.clearString(),
            content_episode: episode?.clearString(),
            content_list: list?.clearString(),
            user_type,
            country,
            user_id,
        }
        this.send(dataLayer, 'G4 [Reproductor - Reproducción de contenido] - sendAdvanceContentEvent');
    }

    public sendInteractionContentEvent(id: string, name: string, type: string, category: string, availability: string, episode: string, list: string,
        user_id: string = this.getUserId(), user_type: string = getUserType(), country: string = getCountry()
        ) {

        if (!this.isEnabled) return;

        const content_id = (id).toString().clearString();

        const dataLayer = {
            event: EVENT_INTERACTION_PLAYER,
            content_id,
            content_name: name?.clearString(),
            content_type: type?.clearString(),
            content_category: category?.clearString(),
            content_availability: availability?.clearString(),
            content_episode: episode?.clearString(),
            content_list: list?.clearString(),
            user_type,
            country,
            user_id,
        }
        this.send(dataLayer, 'G5 [Reproductor - Reproducción de contenido] - sendInteractionContentEvent');
    }

    public sendProgressContentEvent(id: string, name: string, type: string, category: string, availability: string, episode: string, list: string, progress_percentage: string,
        user_id: string = this.getUserId(), user_type: string = getUserType(), country: string = getCountry()) {

        if (!this.isEnabled) return;

        const content_id = (id).toString().clearString();

        const dataLayer = {
            event: EVENT_CONTENT_PROGRESS,
            content_id,
            content_name: name?.clearString(),
            content_type: type?.clearString(),
            content_category: category?.clearString(),
            content_availability: availability?.clearString(),
            progress_percentage: progress_percentage,
            content_episode: episode?.clearString(),
            content_list: list?.clearString(),
            user_type,
            country,
            user_id,
        }
        this.send(dataLayer, 'G6 [Reproductor - Reproducción de contenido] - sendProgressContentEvent');
    }

    /**
     * H1. El evento se debe activar cuando se escriban mínimo 3 letras en el motor de busqueda
     * @param term Termino de búsqueda
     */
    public sendSearchEvent(term: string) {
        if (!this.isEnabled) return;

        const dataLayer = {
            event: EVENT_SEARCH,
            search_term: term?.clearString(),
        }
        this.send(dataLayer, 'H1 [Buscador - Buscador] - sendSearchEvent');
    }

    public sendPrivacyPolices(selection: string = PRIVACY_POLICES_CONTINUE || PRIVACY_POLICES_POLICES || PRIVACY_POLICES_TERMS,
        user_id: string = this.getUserId(),
        user_type: string = getUserType(),
        country: string = getCountry()) {

        if (!this.isEnabled) return;

        const dataLayer = {
            event: EVENT_PRIVACY_POLICES,
            selection: selection,
            method: METHOD_EMAIL,
            user_id,
            user_type,
            country
        }
        this.send(dataLayer, 'I1 [Politicas de Privacidad - Politicas] - sendSearchEvent');
    }

    public sendPlanSelectorRibbonHomePremium({
      content_section = "",
      content_id = "",
      content_name = "",
      content_type = "",
      content_brand = "",
      content_list = "",
      content_price = "",
    }: ISendPlanSelectorRibbonHomePremium) {
      const dataLayer = {
        event: PLAN_SELECTOR,
        content_section,
        content_id,
        content_name: content_name.toLowerCase() || "",
        content_type,
        content_availability: CONTENT_AVAILABILITY_SUBSCRIPTION,
        content_brand: content_brand.toLowerCase() || "",
        content_list,
        content_price,
        user_type: getUserType() || "",
        country: getCountry() || "",
        user_id: this.getUserId() || "",
        device: DEVICE

      }

      this.send(dataLayer, 'plan_selector');

    }

    public sendMetricsPlanSelectorRibbonHomePremium(dataFocused:any, urlFlowType = '') {
      const splitUrlFlowType = urlFlowType.split('/');
      const urlFlowTypeLength = splitUrlFlowType.length;
      const urlFlowTypeIndex = urlFlowTypeLength - 1;
      const section = urlFlowTypeLength > 0 ? splitUrlFlowType[urlFlowTypeIndex] : '';
      const sectionHome = section === HOME_USER || section === HOME_USER_LITE ? HOME_USER_SECTION_G4 : '';
      const sectionPremium = section === NODE_PREMIUM || section === NODE_PREMIUM_LITE ? NODE_PREMIUM_SECTION_G4 : '';
      const contentSection = sectionHome !== '' ? sectionHome : sectionPremium;

      const dataLayer = {
        content_section: contentSection,
        content_id: dataFocused.offerid,
        content_name: dataFocused.title,
        content_type: dataFocused.type,
        content_brand: dataFocused.title,
        content_list: contentSection,
        content_price: `${dataFocused.price.amount}`,
      }
      this.sendPlanSelectorRibbonHomePremium(dataLayer)
  }
}

const transformTypeUsersAdsToMetrics = (type: string) => {
  if (type === Constants.PREMIUM) return Constants.PREMIUM_TO_METRICS_GA;
  else if (type === Constants.FREEMIUM) return Constants.FREEMIUM_TO_METRICS_GA;
  else if (type === Constants.FREEMIUMLOGGED) return Constants.FREEMIUMLOGGED_TO_METRICS_GA;
  else return "";
}

export const getUserType = () => {
    const { user : {isAnonymous = false}= {} } = store.getState() || {};
    if(AdsUtils.isAdsEnable()){
      const type = AdsUtils.getUserType();
      return transformTypeUsersAdsToMetrics(type);
    }else {
      if (isAnonymous) return USER_TYPE_ANONIMO;
      return USER_TYPE_REGISTRADO
    }
}

const getCountry = () => {
    return DeviceStorage.getItem('region') || '';
}



// WEBPACK FOOTER //
// ./src/utils/trackers/GA4.ts